module.exports = __webpack_public_path__ + "static/img/basic.7bb3b5e1.png";